import AggregationInfoChartActions from '../../actions/AggregationInfoChartActions';

export const actions = {
    initAggregationInfoChart() {
        AggregationInfoChartActions.getAggregationInfo();
    }
};
